import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * TODO:
 * this component does not belong as part of `@dcl/ui`
 * as it creates a circular dependency
 * `rehydrate` --> `bundle` <--> `dcl/ui`
 *
 * we should abstract this class and it should belong as part of the `rehydrate` package
 * similar to the `createRehydrateableTest` function for usage in jest
 *
 * `StaticRenderer` is intended for usage in Storybook
 */
import React from "react";
import ReactDOMServer from "react-dom/server";
import { configuration } from "./../../utilities";

var StaticRenderer = /*#__PURE__*/function (_React$Component) {
  _inherits(StaticRenderer, _React$Component);

  var _super = _createSuper(StaticRenderer);

  function StaticRenderer() {
    var _this;

    _classCallCheck(this, StaticRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      markup: []
    });

    _defineProperty(_assertThisInitialized(_this), "ref", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.rehydrate();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.rehydrate();
    });

    _defineProperty(_assertThisInitialized(_this), "rehydrate", function () {
      if (!_this.ref.current) {
        return;
      } // Support for namespacing. Find all elements in this StaticRenderer that
      // have data-rehydratable, and prefix the value with the namespace from
      // our config.


      var rehydratables = Array.from(_this.ref.current.querySelectorAll("[data-rehydratable]"));
      var prefix = "".concat(configuration.current.styles.namespace, "-");

      for (var _i = 0, _rehydratables = rehydratables; _i < _rehydratables.length; _i++) {
        var rehydratable = _rehydratables[_i];
        var rehydratableName = rehydratable.getAttribute("data-rehydratable");

        if (rehydratableName.substr(0, prefix.length) !== prefix) {
          rehydratable.setAttribute("data-rehydratable", "".concat(prefix).concat(rehydratableName));
        }
      }

      _this.props.renderBrowser();
    });

    return _this;
  }

  _createClass(StaticRenderer, [{
    key: "render",
    value: function render() {
      var withoutMarkupContainerAttribute = this.props.withoutMarkupContainerAttribute;
      var markup = this.state.markup;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.ref
      }, markup.map(function (__html, i) {
        return withoutMarkupContainerAttribute ? /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: "".concat(__html)
          },
          key: i
        }) : /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: "<div data-react-from-markup-container>".concat(__html, "</div>")
          },
          key: i
        });
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.separateContainers) {
        return {
          markup: React.Children.map(props.children, function (child) {
            return ReactDOMServer.renderToStaticMarkup(child);
          }) || []
        };
      }

      return {
        markup: [ReactDOMServer.renderToStaticMarkup(props.children)]
      };
    }
  }]);

  return StaticRenderer;
}(React.Component);

_defineProperty(StaticRenderer, "defaultProps", {
  separateContainers: true
});

export default StaticRenderer;